import Dinosaur from "@/assets/Dinosaur.png";
import { Card } from "@/components/ui/card";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

type GenericAlertProps = {
  children: React.ReactNode;
};

export const GenericAlert = (props: GenericAlertProps) => {
  const posthog = usePostHog();

  useEffect(() => {
    posthog.capture("copilot:dino");
  }, [posthog]);

  return (
    <Card className="w-fit">
      <div className="flex flex-col items-center justify-center p-8 pt-4">
        <img src={Dinosaur} alt="Dinosaur" className="w-48 h-auto p-4" />
        {props.children}
      </div>
    </Card>
  );
};
